import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Facebook, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B1C3E] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img
                src="https://customer-assets.emergentagent.com/job_momentum-admin/artifacts/nl8yzv8x_image%20%283%29.png"
                alt="Momentum VA"
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-slate-300 text-sm leading-relaxed">
              Professional virtual assistant support for Australian real estate offices. 
              Building long-term partnerships through reliability and excellence.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=61584309220358"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#2A9D8F] transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/momentumva.au/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#2A9D8F] transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-['Outfit']">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { path: "/about", label: "About Us" },
                { path: "/services", label: "Our Services" },
                { path: "/how-it-works", label: "How It Works" },
                { path: "/careers", label: "Careers" },
                { path: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-300 hover:text-[#2A9D8F] transition-colors text-sm"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-['Outfit']">Services</h4>
            <ul className="space-y-3">
              {[
                "Property Management Support",
                "Sales & Marketing Support",
                "Tenancy Administration",
                "Application Processing",
                "CRM Management",
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-slate-300 hover:text-[#2A9D8F] transition-colors text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-['Outfit']">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#2A9D8F] flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm">
                  Servicing Australian Real Estate<br />
                  Offices Nationwide
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#2A9D8F] flex-shrink-0" />
                <a
                  href="mailto:info@momentumva.com.au"
                  className="text-slate-300 hover:text-[#2A9D8F] transition-colors text-sm"
                  data-testid="footer-email"
                >
                  info@momentumva.com.au
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#2A9D8F] flex-shrink-0" />
                <Link
                  to="/contact"
                  className="text-slate-300 hover:text-[#2A9D8F] transition-colors text-sm"
                >
                  Book a Discovery Call
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} Momentum VA. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-slate-400 hover:text-[#2A9D8F] text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-slate-400 hover:text-[#2A9D8F] text-sm transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
